import type { ScannerIngredient } from '../types/product';

export function getIrritantLevel(ing: ScannerIngredient): string {
  const level = ing.irritant_level;
  if (typeof level === 'object') {
    const val = level.IrritantEnum;
    return typeof val === 'string' ? val.toLowerCase() : 'unknown';
  }
  if (typeof level === 'string') return level.toLowerCase();
  return 'unknown';
}

export function ingredientDisplayName(ing: ScannerIngredient): string {
  return ing.inci_name ?? '—';
}

export function asStringArray(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  return value.filter((item): item is string => typeof item === 'string');
}

export function comedogenicScore(ing: ScannerIngredient): number | null {
  const score = ing.comedogenic_score;
  if (typeof score === 'number' && Number.isFinite(score)) return score;
  if (typeof score === 'string') {
    const parsed = Number(score);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

type ShareCapableNavigator = Navigator & {
  share?: (data: ShareData) => Promise<void>;
};

export function labelize(value?: string | null): string {
  if (!value) return '—';
  return value.replace(/_/g, ' ').replace(/\b\w/g, (m) => m.toUpperCase());
}

export async function shareOrCopyUrl(
  title: string,
  url: string,
  onCopied?: () => void,
): Promise<void> {
  const nav = navigator as ShareCapableNavigator;
  if (typeof nav.share === 'function') {
    await nav.share({ title, url });
    return;
  }
  await navigator.clipboard.writeText(url);
  onCopied?.();
}
